import SelectUvDialog from '@/pages/MainPage/dialogs/SelectUvDialogNew'
import InputModalSelect from '../components/InputModalSelect.jsx'

export default function SelectUv({uiCode, value, ...props}) {
    const getText = multiple => multiple ?
        (value ?? []).map(({uvName}) => uvName).join(',') :
        (value ?? {}).uvName

    return (
        <InputModalSelect
            getText={getText}
            Modal={SelectUvDialog}
            uiCode={uiCode}
            {...props}
        />
    )
}
